import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBadgeEarnedResource } from "../types";

export type IBadgeEarnedQueryParameters = {
    badgeEarned?: RelationalValue<IBadgeEarnedResource>;
};

export type IBadgeEarnedQueryResult = IBadgeEarnedResource;

export const badgeEarnedQuery: IApiQueryFunction<IBadgeEarnedQueryParameters> = ({ badgeEarned }) => {
    if (!badgeEarned) {
        return;
    }

    return {
        method: "GET",
        url: `/badge_earneds/${mapRelationalValue(badgeEarned)}`,
    };
};

export const useBadgeEarnedQuery = createApiQueryHook<IBadgeEarnedQueryParameters, IBadgeEarnedQueryResult>(
    badgeEarnedQuery,
);
